/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Filetypevalidation3Inputs */

const ja_contact_formattachment_filetypevalidation3 = /** @type {(inputs: Contact_Formattachment_Filetypevalidation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードできない形式のファイルが含まれていたため、削除されました。`)
};

const en_contact_formattachment_filetypevalidation3 = /** @type {(inputs: Contact_Formattachment_Filetypevalidation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, we only accept the listed file types. Some files were removed.`)
};

/**
* | output |
* | --- |
* | "Sorry, we only accept the listed file types. Some files were removed." |
*
* @param {Contact_Formattachment_Filetypevalidation3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_filetypevalidation3 = /** @type {((inputs?: Contact_Formattachment_Filetypevalidation3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Filetypevalidation3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_filetypevalidation3(inputs)
	return en_contact_formattachment_filetypevalidation3(inputs)
});
export { contact_formattachment_filetypevalidation3 as "contact_formAttachment_fileTypeValidation" }